import { textGray } from '@osmosis/tailwind-ui/styles/text';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { FormattedMessage } from 'react-intl';
import DividersWrapper from '../DividersWrapper';

/**
 * AuthDivider.
 */
const AuthDivider = () => (
  <DividersWrapper>
    <P className={`${textGray} font-bold`}>
      <FormattedMessage id="auth.divider" defaultMessage="or" />
    </P>
  </DividersWrapper>
);

export default AuthDivider;
